import { useState, useEffect, useCallback } from 'react'
import { Typography, Grid } from '@mui/material'
import { Link } from 'react-router-dom'

import { Card, CardContent } from '@mui/material'
import { useTranslation } from 'react-i18next'
import MethodsTable from './MethodsTable'
import { toast } from 'react-toastify'
import ButtonWrapper from '../../FormUI/ButtonWrapper/ButtonWrapper'
import AddIcon from '@mui/icons-material/Add'
import AppFilters from '../../AppFilters'
import Filters from './Filters'
import { ST_PRODUCTION } from '../../../enums/PaymentMethods'
import { getCache, storeCache } from '../../../services/utils'
import useIsMounted from '../../../hooks/useIsMounted';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { PAYMENT_METHODS__CREATE } from '../../../enums/Caps'
import useHasPermissions from '../../../hooks/useHasPermissions'


export default function MethodsList() {
    const { t } = useTranslation()

    const hasPermissions = useHasPermissions()

    const [loading, setLoading] = useState(true)

    const isMounted = useIsMounted()

    const api = useAxiosPrivate()

    const [params, setParams] = useState(getCache('filters.methods', {
        status: ST_PRODUCTION
    }))

    const [meta, setMeta] = useState({
        total_pages: 1,
        current_page: 1
    })

    const [data, setData] = useState([])

    const handleOnSearch = values => {
        values = {
            ...values,
            status: String(values.status).replace('all', ''),
            api_code: String(values.api_code).replace('all', ''),
            countries__contains: String(values.countries__contains).replace('all', ''),
            method_provider: String(values.method_provider).replace('all', ''),
        }

        setLoading(true)

        storeCache('filters.methods', values, 1)

        setParams(values)
    }

    const handleOnPageChange = (e, page) => {
        setLoading(true)
        setMeta({ ...meta, current_page: page })
        setParams({ ...params, page: page })
    }

    const retrieveData = useCallback(() => {
        api.get('/internal/payment-methods/', { params: params })
            .then((response) => {
                if (isMounted()) {
                    const { data, meta } = response.data;

                    setData(data)

                    if (meta) {
                        setMeta(meta)
                    }
                }
            })
            .catch(() => isMounted() && toast.error(t('Something went wrong')))
            .finally(() => isMounted() && setLoading(false))
    }, [t, params, api, isMounted])

    useEffect(() => {
        const init = () => {
            retrieveData()
        }

        init()
    }, [params, retrieveData])

    return (
        <>
            <Card>
                <CardContent>
                    <Typography variant="h4" mt={2} mb={4}>{t('Payment methods')}</Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            {hasPermissions(PAYMENT_METHODS__CREATE) && (<ButtonWrapper
                                variant="contained"
                                component={Link}
                                to="create"
                                size="small"
                                className="base__btn-action"
                                startIcon={<AddIcon />}>{t('New')}</ButtonWrapper>)}
                        </Grid>
                    </Grid>

                    <AppFilters Filters={<Filters handleOnSearch={handleOnSearch} />} open={true} />

                    <MethodsTable
                        data={data}
                        setData={setData}
                        pages={meta.total_pages}
                        page={meta.current_page}
                        loading={loading}
                        handleOnPageChange={handleOnPageChange}
                    />
                </CardContent>
            </Card>
        </>
    )
}
